import styled from "styled-components";
import Color from "../../../assets/Colors";
import {Link} from "react-router-dom";
import {TypeTitle, TextDescription, ContentContainer} from "../../../styles/Products";

export const CardWhiteCoach = styled.div`
   width: 70%;
   background: white;
   padding: 2em 1.5em;
   margin-top: -7em;
   margin-left: 1em;
   position: relative;

   & .iconDot {
      position: absolute;
      top: -2em;
      width: 4em;
      height: 4em;
   }

   & ${TypeTitle} {
      font-size: 1.6em;
      margin-bottom: 1em;
   }
   & ${TextDescription} {
      font-size: 1.55em;
   }
   @media screen and (max-width: 1600px) {
      padding: 1.3em;
      margin-top: -6.7em;

      & .iconDot {
         top: -1.5em;
         width: 2.5em;
         height: 2.5em;
      }

      & ${TypeTitle} {
         font-size: 1.3em;
      }
      & ${TextDescription} {
         font-size: 1.1em;
      }
   }

   @media screen and (max-width: 500px) {
      width: 90%;
      margin-top: -5em;

      & .iconDot {
         top: -1.5em;
         width: 2.5em;
         height: 2.5em;
         left: 1em;
      }

      & ${TypeTitle} {
         font-size: 1.1em;
      }
      & ${TextDescription} {
         font-size: 1em;
      }
   }
`;

export const CardCoach = styled.div`
   width: ${(props) => (props.isfully ? "100%" : "49.5%")};
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   margin-bottom: 2em;
   
   &.full {
      width: 100%;
   }

   &:nth-child(odd) {
      margin-right: 0.5%;
   }

   & img.profileImg {
      width: 100%;
      margin-bottom: 1em;
   }
   & ${CardWhiteCoach} {
      // width: ${(props) => (props.width === "100%" ? "45%" : "70%")};
      width: 70%;
      @media screen and (max-width: 500px) {
         width: 90%;
      }
   }

   @media screen and (max-width: 500px) {
      width: 100%;
      margin-bottom: 2em;

      &.noMarginMobile {
         margin-bottom: 0;
      }
   }
`;

export const CardFull = styled.div`
   width: 100%;
   display: flex;
   justify-content: flex-end;

   & ${CardCoach} {
      width: 70%;
      position: relative;
      & ${CardWhiteCoach} {
         position: absolute;
         bottom: 0;
         left: 1em;
         margin-top: 0;
         width: auto;
         padding: 1em 2em;

         & p {
            font-size: 1.5em;
            margin: 0;
         }
      }
   }

   @media screen and (max-width: 1600px) {
      & ${CardCoach} {
         & ${CardWhiteCoach} {
            & p {
               font-size: 1.1em;
            }
         }
      }
   }

   @media screen and (max-width: 500px) {
      & ${CardCoach} {
         width: 100%;
      }
   }
`;

export const CoachList = styled(ContentContainer)`
   display: flex;
   justify-content: space-around;

   @media screen and (max-width: 500px) {
      flex-direction: column;
   }
`;

export const InfoCoach = styled.div`
   widht: 100%;
   padding: 0.5em 0;
   display: flex;
   justify-content: center;
   & .info {
      width: 40%;
      display: flex;
      align-items: center;
      & .iconInfo {
         width: 20px;
         height: 20px;
         margin-right: 0.5em;
      }
   }
   & .titleInfo {
      font-size: 0.9em;
   }
   & .nameInfo {
      font-size: 0.9em;
   }
   & .info:last-child {
      width: 60%;
      padding-left: 0.5em;
      border-left: 1px solid grey;
   }
   @media screen and (max-width: 1600px) {
      & .titleInfo {
         font-size: 0.7em;
      }
      & .nameInfo {
         font-size: 0.9em;
      }
   }
`;

export const ActionBio = styled(Link)`
   font-weight: 400;
   color: ${Color.secondary};
   font-size: 1.3em;
   line-height: 1.7em;
   margin-top: 1.5em;

   display: flex;
   align-items: center;

   & .mediaIcon {
      width: 1em;
      height: 1.1em;
      margin-left: 0.5em;
      padding-top: 7px;
   }
   &.disable {
      user-select: none;
      opacity: 0;
   }

   @media screen and (max-width: 1600px) {
      font-size: 1.1em;
      line-height: 1.4em;
      margin-top: 1em;
   }

   @media screen and (max-width: 500px) {
      font-size: 1em;
      line-height: 1.1em;
      margin-top: 1.2em;
   }
`;
